import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import Alert from '../../components/alert';
import FacebookButton from '../../containers/facebook-button.container';
import SigninModalForm from './signin-modal-form';

import '../../css/account-modals.css';

import logo from '../../img/keytravel-logo-white.png';

class SigninModal extends Component {

  state = {
    error: null,
    clearForm: false,
  }

  componentDidMount() {
    if (window.location.hash === '#signin') {
      window.$('#signin').modal('show');
    }

    window.$('#signin').on('hide.bs.modal', () => {
      window.location.hash = '#';
      this.setState({
        clearForm: true,
      });
    });
  }

  onClearForm = () => {
    this.setState({
      clearForm: false,
    });
  }

  onSubmitError = (error) => {
    this.setState({
      error,
    })
  }

  onSignin = (email, password) => {
    return this.props.onSignin(email, password)
      .then(() => {
        this.hideThisModal();
      });
  }

  onSignupClick = () => {
    this.hideThisModal();
    this.props.onEmailChange('')
      .then(() => window.$('#signup').modal('show'));

  }

  onForgotClick = () => {
    this.hideThisModal();
    window.$('#password-reset').modal('show');
  }

  onFacebookLogin = () => {
    this.hideThisModal();
  }

  hideThisModal = () => {
    window.$('body').removeClass('modal-open');
    window.$('#signin').modal('hide');
    window.$('.modal-backdrop').hide();
    window.location.hash = '#';
    this.setState({
      clearForm: true,
    });
  }

  renderFacebookButton() {
    return (
      <div className="modal-section divider">
        <FacebookButton onConnect={this.onFacebookLogin}>
          <FormattedMessage
            id="signinModal.facebookButton"
            defaultMessage="Sign in with Facebook"
          />
        </FacebookButton>
      </div>
    );
  }

  renderAlert() {
    if (!this.state.error) return null;

    return (
      <Alert type="warning" className="alert-form-top">
        <i className="fa fa-fw fa-ban" />
        {this.state.error}
      </Alert>
    );
  }

  render() {
    if (this.props.currentUser) return null;

    return (
      <div id="signin" className="accounts-modal modal" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content rounded">
            <div className="modal-header">
              <h5 className="modal-title pb-0 d-block w-100 text-center">
                <img src={logo} alt="Pay by group" height="24" />
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.hideThisModal()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </h5>
            </div>
            <div className="modal-body">
              {this.renderAlert()}
              <div className="modal-section modal-title text-center divider">
                <h1>
                  <FormattedMessage
                    id="signinModal.pageTitle"
                    defaultMessage="Sign in"
                  />
                </h1>
                <div className="text-muted">
                  <FormattedMessage
                    id="signinModal.welcomeText"
                    defaultMessage="Welcome back"
                  />
                </div>
              </div>
              {this.renderFacebookButton()}

              <SigninModalForm
                existence={this.props.existence}
                onEmailChange={this.props.onEmailChange}
                onClickSendMagicLink={this.props.onClickSendMagicLink}
                onSignin={this.onSignin}
                onSubmitError={this.onSubmitError}
                onForgotClick={this.onForgotClick}
                clearForm={this.state.clearForm}
                onClearForm={this.onClearForm}
              />

              <div className="modal-section no-account">
                <p className="text-muted">
                  <FormattedMessage
                    id="signinModal.signupCopy"
                    defaultMessage="Don't have an account?"
                  />
                  {' '}
                  <a
                    href="#signup"
                    onClick={this.onSignupClick}
                  >
                    <FormattedMessage
                      id="signinModal.signupLink"
                      defaultMessage="Sign up"
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SigninModal;



// WEBPACK FOOTER //
// ./src/desktop/components/signin-modal/signin-modal.js